<template>
  <div>
    <div class="image-holder">
      <h3>Add {{title}} Image</h3>
      <div class="grouped-context" >

        <img v-if="getUserData.profileUrl" v-bind:src="getUserData.profileUrl" class="image"/>
        <div v-else class="image no-image"></div>

        <div class="upload-btn">
          <button
            class="file-button"
            @click="$refs.myFile.click()"
          >
            Choose file
          </button>
          <input
            type="file"
            placeholder="Upload CoverImage"
            ref="myFile"
            @change="uploadFile"
            hidden
          />
          <p v-bind:class="{'error-text': imageError}">Image should be maximum file size of 400KB - JPG, PNG or GIF</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageUpload',
  props: ['title'],
  data() {
    return {
      selectedImage: null,
      previewImage: null,
      imageError: null
    };
  },
  methods: {
    uploadFile(e){
      if
      (
        (e.target.files[0].type === 'image/jpeg' ||
        e.target.files[0].type === 'image/png' ||
        e.target.files[0].type === 'image/gif') &&
        e.target.files[0].size <= 400000
      ) {
        this.selectedImage = e.target.files[0];
        this.$store.dispatch('profileUpload', this.selectedImage)
        .then((res) => {
          if(res.response) {
            this.previewImage = this.$store.state.userData.profileUrl;
            this.$toastr.success(res.response, 'Success');
          } else {
            this.$toastr.error(res.error.error, 'Failed');
          }
        });
        this.imageError = false;
      } else {
        this.imageError = true;
      }
    }
  },
  computed: {
    getUserData() {
      return this.$store.state.userData;
    }
  },
};
</script>

<style scoped>
  .image-holder {
    margin-bottom: 40px;
  }
  h3 {
    font-family: 'montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 1.125rem;
    line-height: 21.94px;
    color: var(--colorSecondary);
  }
  .grouped-context {
    display: flex;
    align-items: center;
    margin-top: 30px;
  }
  .no-image {
    background: var(--colorPrimary);
  }
  img.image {
    width: 250px;
    border-radius: 100%;
    max-height: 150px;
    object-fit: cover;
    margin-right: 35px;
  }
  .file-button {
    min-width: 150px;
    background: var(--colorPrimary);
    color: var(--white);
    border-radius: 5px;
    padding: 10px 35px;
    font-weight: 600;
  }
  p {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #5B5B5B;
    margin-top: 17px;
  }
  .error-text {
  color: tomato;
  }
  @media only screen and (max-width: 480px) {
    .grouped-context {
      flex-direction: column;
    }
    .grouped-context > div {
      text-align: center;
      margin-top: 40px;
    }
    img.image {
      margin-right: 0;
    }
    .image-holder {
      text-align: center;
    }
  }
</style>
